import { Appliance } from '../models/appliance-content.interface';

export const applianceContent: Appliance[] = [
  {
    applianceCode: 'GENERIC',
    title: 'Protect yourself from unexpected repair bills',
    guaranteeTitle:
      'Your manufacturer guarantee doesn’t cover everything. Add extra protection today...',
    protectionPanelTitle: 'Protect your {{ brandName }} Appliance',
    subtitle:
      'Problems with your appliance happen more often than we think. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement appliance if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: "Our policy gives you cover where your guarantee doesn't. We'll cover it if you damage it accidentally, during and after your guarantee period. Plus we'll cover breakdowns from the end of your guarantee, for as long as you like.",
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: "Unlike some policies, there's no charge for call-outs, parts or labour. Simply book as many repairs as you need.",
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: "If your appliance is beyond repair, we'll replace it with the same or a similar model. You'll only pay for installation and recycling your old appliance, if needed.",
        title:
          "Replacement with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Engineer',
      src: 'assets/images/generic-appliance.png',
    },
  },
  {
    applianceCode: 'D-',
    title: 'Protect your dishwasher from unexpected repair bills',
    guaranteeTitle:
      'Your Dishwasher’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Dishwasher',
    subtitle:
      'Clogged pumps, short circuits, torn hoses... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement dishwasher if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged pumps, circuit faults from water leaks, torn hoses - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your dishwasher with the same or a similar model. You’ll only pay for installation and recycling your old dishwasher, if needed.',
        title:
          "Replacement dishwasher with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Dishwasher',
      src: 'assets/images/dishwasher.jpg',
    },
  },
  {
    applianceCode: 'DW',
    title: 'Protect your dishwasher from unexpected repair bills',
    guaranteeTitle:
      'Your Dishwasher’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Dishwasher',
    subtitle:
      'Clogged pumps, short circuits, torn hoses... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement dishwasher if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged pumps, circuit faults from water leaks, torn hoses - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your dishwasher with the same or a similar model. You’ll only pay for installation and recycling your old dishwasher, if needed.',
        title:
          "Replacement dishwasher with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Dishwasher',
      src: 'assets/images/dishwasher.jpg',
    },
  },
  {
    applianceCode: 'LY',
    title: 'Protect your TV from unexpected repair bills',
    guaranteeTitle:
      'Your TV’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} TV',
    subtitle:
      'Cracked screens, torn cables, spilt liquid... these things happen. But with the {{ brandName}} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement TV if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: cracked screens, spilled liquid, overheating, torn cables and falling off the wall or furniture, to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your TV with the same or a similar model. You’ll only pay for installation and recycling your old TV, if needed.',
        title:
          "Replacement TV with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Television',
      src: 'assets/images/tv.jpg',
    },
  },
  {
    applianceCode: 'CT',
    title: 'Protect your TV from unexpected repair bills',
    guaranteeTitle:
      'Your TV’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} TV',
    subtitle:
      'Cracked screens, torn cables, spilt liquid... these things happen. But with the {{ brandName}} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement TV if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: cracked screens, spilled liquid, overheating, torn cables and falling off the wall or furniture, to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your TV with the same or a similar model. You’ll only pay for installation and recycling your old TV, if needed.',
        title:
          "Replacement TV with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Television',
      src: 'assets/images/tv.jpg',
    },
  },
  {
    applianceCode: 'UT',
    title: 'Protect your TV from unexpected repair bills',
    guaranteeTitle:
      'Your TV’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} TV',
    subtitle:
      'Cracked screens, torn cables, spilt liquid... these things happen. But with the {{ brandName}} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement TV if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: cracked screens, spilled liquid, overheating, torn cables and falling off the wall or furniture, to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your TV with the same or a similar model. You’ll only pay for installation and recycling your old TV, if needed.',
        title:
          "Replacement TV with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Television',
      src: 'assets/images/tv.jpg',
    },
  },
  {
    applianceCode: 'A-',
    title: 'Protect your washing machine from unexpected repair bills',
    guaranteeTitle:
      'Your Washing Machine’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Washing Machine',
    subtitle:
      'Clogged filters, water leaks, keys or coins stuck inside... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement washing machine if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged filters, circuit faults from water leaks, coins or keys stuck in the mechanism - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your washing machine with the same or a similar model. You’ll only pay for installation and recycling your old washing machine, if needed.',
        title:
          "Replacement washing machine with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Washing Machine',
      src: 'assets/images/washing-machine.jpg',
    },
  },
  {
    applianceCode: 'AW',
    title: 'Protect your washing machine from unexpected repair bills',
    guaranteeTitle:
      'Your Washing Machine’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Washing Machine',
    subtitle:
      'Clogged filters, water leaks, keys or coins stuck inside... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement washing machine if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged filters, circuit faults from water leaks, coins or keys stuck in the mechanism - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your washing machine with the same or a similar model. You’ll only pay for installation and recycling your old washing machine, if needed.',
        title:
          "Replacement washing machine with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Washing Machine',
      src: 'assets/images/washing-machine.jpg',
    },
  },
  {
    applianceCode: 'W-',
    title: 'Protect your washer dryer from unexpected repair bills',
    guaranteeTitle:
      'Your Washer Dryer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Washer Dryer',
    subtitle:
      'Clogged filters, water leaks, keys or coins stuck inside... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement washer dryer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged filters, circuit faults from water leaks, coins or keys stuck in the mechanism - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your washer dryer with the same or a similar model. You’ll only pay for installation and recycling your old washer dryer, if needed.',
        title:
          "Replacement washer dryer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Washer Dryer',
      src: 'assets/images/washing-machine.jpg',
    },
  },
  {
    applianceCode: 'WD',
    title: 'Protect your washer dryer from unexpected repair bills',
    guaranteeTitle:
      'Your Washer Dryer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Washer Dryer',
    subtitle:
      'Clogged filters, water leaks, keys or coins stuck inside... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement washer dryer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged filters, circuit faults from water leaks, coins or keys stuck in the mechanism - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your washer dryer with the same or a similar model. You’ll only pay for installation and recycling your old washer dryer, if needed.',
        title:
          "Replacement washer dryer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Washer Dryer',
      src: 'assets/images/washing-machine.jpg',
    },
  },
  {
    applianceCode: 'T-',
    title: 'Protect your tumble dryer from unexpected repair bills',
    guaranteeTitle:
      'Your Tumble Dryer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Tumble Dryer',
    subtitle:
      'Clogged filters, water leaks, keys or coins stuck inside... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement tumble dryer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged filters, circuit faults from water leaks, coins or keys stuck in the mechanism - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your tumble dryer with the same or a similar model. You’ll only pay for installation and recycling your old tumble dryer, if needed.',
        title:
          "Replacement tumble dryer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Tumble Dryer',
      src: 'assets/images/tumble-dryer.jpg',
    },
  },
  {
    applianceCode: 'TD',
    title: 'Protect your tumble dryer from unexpected repair bills',
    guaranteeTitle:
      'Your Tumble Dryer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Tumble Dryer',
    subtitle:
      'Clogged filters, water leaks, keys or coins stuck inside... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement tumble dryer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged filters, circuit faults from water leaks, coins or keys stuck in the mechanism - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your tumble dryer with the same or a similar model. You’ll only pay for installation and recycling your old tumble dryer, if needed.',
        title:
          "Replacement tumble dryer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Tumble Dryer',
      src: 'assets/images/tumble-dryer.jpg',
    },
  },
  {
    applianceCode: 'EA',
    title: 'Protect your tumble dryer from unexpected repair bills',
    guaranteeTitle:
      'Your Tumble Dryer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Tumble Dryer',
    subtitle:
      'Clogged filters, water leaks, keys or coins stuck inside... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement tumble dryer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: broken door latches or hinges, clogged filters, circuit faults from water leaks, coins or keys stuck in the mechanism - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your tumble dryer with the same or a similar model. You’ll only pay for installation and recycling your old tumble dryer, if needed.',
        title:
          "Replacement tumble dryer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Tumble Dryer',
      src: 'assets/images/tumble-dryer.jpg',
    },
  },
  {
    applianceCode: 'F=',
    title: 'Protect your fridge freezer from unexpected repair bills',
    guaranteeTitle:
      'Your Fridge Freezer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Fridge Freezer',
    subtitle:
      'Torn seals, electrical damage, broken shelves... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement fridge freezer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: torn seals, electrical damage, broken shelves, cracked interior lights, pets chewing through wires - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your fridge freezer with the same or a similar model. You’ll only pay for installation and recycling your old fridge freezer, if needed.',
        title:
          "Replacement fridge freezer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Fridge Freezer',
      src: 'assets/images/fridge.jpg',
    },
  },
  {
    applianceCode: 'FF',
    title: 'Protect your fridge freezer from unexpected repair bills',
    guaranteeTitle:
      'Your Fridge Freezer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Fridge Freezer',
    subtitle:
      'Torn seals, electrical damage, broken shelves... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement fridge freezer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: torn seals, electrical damage, broken shelves, cracked interior lights, pets chewing through wires - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your fridge freezer with the same or a similar model. You’ll only pay for installation and recycling your old fridge freezer, if needed.',
        title:
          "Replacement fridge freezer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Fridge Freezer',
      src: 'assets/images/fridge.jpg',
    },
  },
  {
    applianceCode: 'R-',
    title: 'Protect your fridge from unexpected repair bills',
    guaranteeTitle:
      'Your Fridge’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Fridge',
    subtitle:
      'Torn seals, electrical damage, broken shelves... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement fridge if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: torn seals, electrical damage, broken shelves, cracked interior lights, pets chewing through wires - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your fridge with the same or a similar model. You’ll only pay for installation and recycling your old fridge, if needed.',
        title:
          "Replacement fridge with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Fridge',
      src: 'assets/images/fridge.jpg',
    },
  },
  {
    applianceCode: 'FR',
    title: 'Protect your fridge from unexpected repair bills',
    guaranteeTitle:
      'Your Fridge’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Fridge',
    subtitle:
      'Torn seals, electrical damage, broken shelves... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement fridge if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: torn seals, electrical damage, broken shelves, cracked interior lights, pets chewing through wires - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your fridge with the same or a similar model. You’ll only pay for installation and recycling your old fridge, if needed.',
        title:
          "Replacement fridge with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Fridge',
      src: 'assets/images/fridge.jpg',
    },
  },
  {
    applianceCode: 'FS',
    title: 'Protect your fridge freezer from unexpected repair bills',
    guaranteeTitle:
      'Your Fridge Freezer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Fridge Freezer',
    subtitle:
      'Torn seals, electrical damage, broken shelves... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement fridge freezer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: torn seals, electrical damage, broken shelves, cracked interior lights, pets chewing through wires - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your fridge freezer with the same or a similar model. You’ll only pay for installation and recycling your old fridge freezer, if needed.',
        title:
          "Replacement fridge freezer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Freezer',
      src: 'assets/images/fridge.jpg',
    },
  },
  {
    applianceCode: 'N-',
    title: 'Protect your fridge freezer from unexpected repair bills',
    guaranteeTitle:
      'Your Fridge Freezer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Fridge Freezer',
    subtitle:
      'Torn seals, electrical damage, broken shelves... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement fridge freezer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: torn seals, electrical damage, broken shelves, cracked interior lights, pets chewing through wires - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your fridge freezer with the same or a similar model. You’ll only pay for installation and recycling your old fridge freezer, if needed.',
        title:
          "Replacement fridge freezer with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Freezer',
      src: 'assets/images/fridge.jpg',
    },
  },
  {
    applianceCode: 'CN',
    title: 'Protect your fridge freezer from unexpected repair bills',
    guaranteeTitle:
      'Your Fridge Freezer’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Fridge Freezer',
    subtitle:
      'Torn seals, electrical damage, broken shelves... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement fridge freezer if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'For example: torn seals, electrical damage, broken shelves, cracked interior lights, pets chewing through wires - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your fridge freezer with the same or a similar model. You’ll only pay for installation and recycling your old fridge freezer, if needed.',
        title:
          "Replacement fridge freezer  with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Freezer',
      src: 'assets/images/fridge.jpg',
    },
  },
  {
    applianceCode: 'C-',
    title: 'Protect your cooker from unexpected repair bills',
    guaranteeTitle:
      'Your Cooker’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Cooker',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement cooker if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your cooker with the same or a similar model. You’ll only pay for installation and recycling your old cooker, if needed.',
        title:
          "Replacement cooker with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Cooker',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'CK',
    title: 'Protect your cooker from unexpected repair bills',
    guaranteeTitle:
      'Your Cooker’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Cooker',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement cooker if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your cooker with the same or a similar model. You’ll only pay for installation and recycling your old cooker, if needed.',
        title:
          "Replacement cooker with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Cooker',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'O-',
    title: 'Protect your oven from unexpected repair bills',
    guaranteeTitle:
      'Your Oven’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Oven',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement oven if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your oven with the same or a similar model. You’ll only pay for installation and recycling your old oven, if needed.',
        title:
          "Replacement oven with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Oven',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'OV',
    title: 'Protect your oven from unexpected repair bills',
    guaranteeTitle:
      'Your Oven’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Oven',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement oven if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your oven with the same or a similar model. You’ll only pay for installation and recycling your old oven, if needed.',
        title:
          "Replacement oven with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Oven',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'EO',
    title: 'Protect your oven from unexpected repair bills',
    guaranteeTitle:
      'Your Oven’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Oven',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement oven if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your oven with the same or a similar model. You’ll only pay for installation and recycling your old oven, if needed.',
        title:
          "Replacement oven with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Oven',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'EC',
    title: 'Protect your cooker from unexpected repair bills',
    guaranteeTitle:
      'Your Cooker’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Cooker',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement cooker if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your cooker with the same or a similar model. You’ll only pay for installation and recycling your old cooker, if needed.',
        title:
          "Replacement cooker with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Cooker',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'O=',
    title: 'Protect your oven from unexpected repair bills',
    guaranteeTitle:
      'Your Oven’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Oven',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement oven if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your oven with the same or a similar model. You’ll only pay for installation and recycling your old oven, if needed.',
        title:
          "Replacement oven with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Oven',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'DO',
    title: 'Protect your oven from unexpected repair bills',
    guaranteeTitle:
      'Your Oven’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Oven',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement oven if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your oven with the same or a similar model. You’ll only pay for installation and recycling your old oven, if needed.',
        title:
          "Replacement oven with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Oven',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'RQ',
    title: 'Protect your cooker from unexpected repair bills',
    guaranteeTitle:
      'Your Cooker’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Cooker',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement cooker if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your cooker with the same or a similar model. You’ll only pay for installation and recycling your old cooker, if needed.',
        title:
          "Replacement cooker with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Cooker',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'GC',
    title: 'Protect your cooker from unexpected repair bills',
    guaranteeTitle:
      'Your Cooker’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Cooker',
    subtitle:
      'Cracked stovetops, broken hinges, short circuits... these things happen. But with the {{ brandName }} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement cooker if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Bent racks, short circuits, cracked stovetops, broken hinges - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your cooker with the same or a similar model. You’ll only pay for installation and recycling your old cooker, if needed.',
        title:
          "Replacement cooker with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Cooker',
      src: 'assets/images/cooker.jpg',
    },
  },
  {
    applianceCode: 'C=',
    title: 'Protect your vacuum cleaner from unexpected repair bills',
    guaranteeTitle:
      'Your Vacuum Cleaner’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Vacuum Cleaner',
    subtitle:
      'Clogged filters, frayed power cords, overheated motors... these things happen. But with the {{ brandName}} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement vacuum cleaner if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Cracked housing, frayed power cords, clogged filters, overheated motors - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your vacuum cleaner with the same or a similar model. You’ll only pay for installation and recycling your old vacuum cleaner, if needed.',
        title:
          "Replacement vacuum cleaner with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Vacuum cleaner',
      src: 'assets/images/vacuum-cleaner.jpg',
    },
  },
  {
    applianceCode: 'CL',
    title: 'Protect your vacuum cleaner from unexpected repair bills',
    guaranteeTitle:
      'Your Vacuum Cleaner’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Vacuum Cleaner',
    subtitle:
      'Clogged filters, frayed power cords, overheated motors... these things happen. But with the {{ brandName}} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement vacuum cleaner if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Cracked housing, frayed power cords, clogged filters, overheated motors - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'If it’s beyond repair, we’ll replace your vacuum cleaner with the same or a similar model. You’ll only pay for installation and recycling your old vacuum cleaner, if needed.',
        title:
          "Replacement vacuum cleaner with same or similar features, if it can't be fixed",
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Vacuum cleaner',
      src: 'assets/images/vacuum-cleaner.jpg',
    },
  },
  {
    applianceCode: 'ES',
    title: 'Protect your electric shower from unexpected repair bills',
    guaranteeTitle:
      'Your Electric Shower’s guarantee doesn’t cover it all - Add extra protection today.',
    protectionPanelTitle: 'Protect your {{ brandName }} Electric Shower',
    subtitle:
      'Cracked shower heads, short circuits, overheated elements... these things happen. But with the {{ brandName}} Protection Policy, you’ll have cover for accidental damage (not covered by your guarantee) – plus a replacement electric shower if yours can’t be fixed.',
    accordion: [
      {
        body: 'Your manufacturer guarantee covers for you breakdowns for {{ warrantyInMonths }} months. ​Our plan will give you coverage after the guarantee period ends for breakdown coverage and more.',
        title: 'Cover for breakdowns & faults',
      },
      {
        body: 'Leaking connections, short circuits, cracked shower heads, overheated elements - to name a few. It’s all too easy to bump, drop, knock or spill something that causes damage. Our policy covers these now, plus breakdown cover after your guarantee ends.',
        title: 'Accidental damage',
        guaranteeType: 'excluded',
      },
      {
        body: 'Unlike some policies, there’s no charge for call-outs, parts or labour. Simply book as many repairs as you need.',
        title: 'Unlimited repairs',
        guaranteeType: 'breakdown-only',
      },
      {
        body: 'When your appliance is beyond repair we will provide vouchers or cash towards a replacement.',
        title: 'Vouchers or cash towards a replacement if it can’t be fixed',
        guaranteeType: 'breakdown-only',
      },
    ],
    picture: {
      alt: 'Electric Shower',
      src: 'assets/images/electric-shower.jpg',
    },
  },
];
